import styled, { css } from "styled-components";
import { useSelector } from "react-redux";
import ScrollAnimation from "react-animate-on-scroll";

import { scrollAnimationProps as animationProps } from "globalConstants";

import * as Types from "Types";
import * as grid from "grid";

import Content1 from "Components/Molecules/SectionAbout/Content1";
import Content2 from "Components/Molecules/SectionAbout/Content2";
import Content3 from "Components/Molecules/SectionAbout/Content3";
import Devices from "Components/Molecules/SectionAbout/Devices";

const Wrap = styled.div<any>`
   position: relative;
   margin-top: 85px;
   text-align: center;
   display: flex;
   flex-direction: column;
   align-items: center;
   & .animated {
      transition-duration: 1s;
      transition-property: opacity;
      transition-timing-function: ease-in-out;
      opacity: 0;
   }
   & .scrollAnimation {
      opacity: 1;
   }
   ${({ XSCss }) => XSCss}
   ${({ css }) => css}
`;

const Animation = styled(ScrollAnimation)<Types.Default>`
   display: flex;
   justify-content: center;
   width: 1000px;
   max-width: 100%;
   ${({ css }) => css}
`;

export default function SectionAbout(props: Types.Default) {
   const windowWidth = useSelector(({ dimensions }: Types.State) => dimensions.width);

   const size = grid.getSize(windowWidth);
   const XSCss = size === grid.sizes.xs && css``;

   return (
      <Wrap {...props} XSCss={XSCss}>
         <Animation {...animationProps}>
            <Content1></Content1>
         </Animation>
         <Content2></Content2>
         <Animation {...animationProps}>
            <Devices></Devices>
         </Animation>
         <Content3></Content3>
      </Wrap>
   );
}
